import { ReactNode } from 'react';

import { Button, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

type TDropdownAnchor = {
  anchorContent: ReactNode;
  open: boolean;
  spacing: string[];
  dataTestid?: string;
  withChevronIcon?: boolean;
};

export const DropdownAnchor = ({
  anchorContent,
  open,
  dataTestid,
  withChevronIcon = true,
}: TDropdownAnchor) => (
  // TODO: move icon inside of iconRight props of the MenuButton
  <MenuTrigger asChild>
    <Button borderRadius={5} variant="ghost" data-testid={dataTestid} size="md">
      {anchorContent}
      {withChevronIcon && (
        <>
          <Spacer size="sm" />
          <Icon
            name={open ? iconNames.chevronUp : iconNames.chevronDown}
            width="12px"
            height="7px"
            stroke="var(--fgPrimary)"
          />
        </>
      )}
    </Button>
  </MenuTrigger>
);
